import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {ApiService} from '../../core/http/api.service';
import {environment} from '../../../environments/environment';
import {ToastrService} from 'ngx-toastr';
import {Location} from "@angular/common";

@Component({
    selector: 'app-nft-single-collection',
    templateUrl: './nft-single-collection.component.html',
    styleUrls: ['./nft-single-collection.component.css'],
    standalone: false
})
export class NftSingleCollectionComponent implements OnInit {

  collectionId: any;
  collection: any;
  uploading = false;
  uploaded = false;
  addData = {
    collection: '',
    title: '',
    image: '',
    url: ''
  };
  addMode = false;

  constructor(
    private route: ActivatedRoute,
    private api: ApiService,
    private toastr: ToastrService,
    private _location: Location) {
    route.params.subscribe(params => {
      this.collectionId = params.id;
    });
  }

  ngOnInit(): void {
    this.getSingleCollection();
  }

  getSingleCollection(): void {
    this.api.getSingleCollection(this.collectionId).subscribe(res => {
      this.collection = res.response;
    }, err => alert(err.error.message));
  }

  addNFT(): void {
    this.api.newNft(this.addData).subscribe(res => {
      this.uploading = false;
      this.uploaded = false;
      this.addMode = false;
      this.addData = {collection: '', title: '', image: '', url: ''};
      this.getSingleCollection();
    });
  }

  uploadImage(e): void {
    this.uploading = true;
    this.api.fileUpload({file: e.target.files[0]}, 'file').subscribe(res => {
      this.addData.image = res.url;
      this.addData.collection = this.collectionId;
      this.uploading = false;
      this.uploaded = true;
    }, err => {
      this.uploading = false;
    });
  }

  toggleNFT(id): void {
    this.api.nftStatusUpdate(id).subscribe(res => {
      this.toastr.success('Status updated successfully!');
      this.getSingleCollection();
    }, err => {
      this.toastr.error(err.error.message);
    });
  }
}
